import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { tryFireOpenPanelPageLand } from '../utils/openpanelPageLand';
import { trackOpenPanelScreenView } from '../utils/openpanelInit';

/** screen_view (UTM on __path/__query) + named page-land — once per route (no double-fire). */
export default function useOpenPanelPageLand() {
  const { pathname } = useLocation();

  useEffect(() => {
    const fire = () => {
      trackOpenPanelScreenView(pathname);
      tryFireOpenPanelPageLand(pathname);
    };

    // If OpenPanel already ready, fire once. Otherwise wait for ready (avoids
    // fire() + ready both sending HomepageLanded).
    if (typeof window !== 'undefined' && window.__daivOpenPanelInitialized) {
      fire();
      return undefined;
    }

    window.addEventListener('daiv-openpanel-ready', fire);
    return () => window.removeEventListener('daiv-openpanel-ready', fire);
  }, [pathname]);
}
